import PriceQuery from './PriceQuery';

export default PriceQuery;
